<template>
  <div
    :style="{ 'color': ColorContent, 'font-size': `${FontSizeContent}px`, 'font-family': FontContent }"
    style="text-align: center; padding: 15px"
  >
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    name: 'itemDemo',
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
  }
</script>
